import { useMemo } from 'react';
import { useGetPackagesByTypeQuery } from '../api';
/**
 * Hook to get all document packages for a specific package type.
 *
 * @param projectId the project id that the packages belong to.
 * @param type the type of the packages.
 *
 * @returns an object with a list of document packages, loading state, error state and error object.
 */
export const usePackages = (projectId, type) => {
    const { data: packages = [], isLoading, isError, error, } = useGetPackagesByTypeQuery({ projectId, type });
    return useMemo(() => ({
        packages,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, packages]);
};
